var Events = require('f.core.event');


var formatData = function (type, data) {
  for (var i = 0, iLen = data.length; i < iLen; i++) {
    data[i].__type = type;
  }
  return data;
};

var formatDatas = function (msg) {
  if (Array.isArray(msg)) {
    return {};
  }
  var items;
  var result = [];
  for (var key in msg) {
    items = msg[key];
    items = formatData('danma', items);
    result = result.concat(items);
  }
  console.log(result);
  return result;
};

var DataCenter = function (liveid, message, title) {
  this.message = message;
  this.liveid = liveid;
  this.title = title;
  this.cacheIds = {};
  this.isStart = true;
  this.init();
};

DataCenter.prototype.init = function () {
  this.initEvent();
};

DataCenter.prototype.initData = function () {
  const id = this.liveid;
  $.ajax({
    url: window.location.protocol + '//danmaku.ifeng.com/get/recent/' + id,
    type: 'get',
    dataType: 'jsonp',
    data: {
      format: 'jsonp'
    },
    success: function (msg) {
      console.log(msg)
      if (typeof msg.code !== 'undefined' && msg.code !== 1) {
        return;
      }
      var datas = formatDatas(msg);
      this.trigger('data', 'danma', datas);
    }.bind(this)
  });
};

DataCenter.prototype.initEvent = function () {

  var dealData = function (data) {
    if (!this.isStart) {
      return;
    }
    console.log('~~~~~~~~~~~~~',data)
    var list = formatData(data.type, data.data);
    if (list.length > 0) {
      // list = this.fliteById(list);
      this.trigger('data', data.type, list);
    }
  };

  this.message.on('danma:list', 201, dealData.bind(this));
  this.message.on('gift:list', 204, dealData.bind(this));
  this.message.on('online:list', 201, dealData.bind(this));
  this.message.on('praise:list', 201, dealData.bind(this));

  var isFirst = true;
  this.message.event.on('open', () => {
    if (isFirst == true) {
      isFirst = false;
      this.initData();
    }
  })

};

var sendIndex = 0;

DataCenter.prototype.sendData = function (data, offset ,commandid) {
  var data = {
    // article_id: this.message.liveid,
    title: this.title,
    url: window.location.href,
    content: data.val,
    fontsize: data.size,
    color: data.color
    // app: 'h5',
    // type: 'realtime'
  };
  this.message.send('danma', commandid, data).catch(function () {

  });
  data.id = 'sendBack_' + sendIndex++;
  this.trigger('send', [data]);
};

DataCenter.prototype.fliteById = function (data) {
  var cacheIds = this.cacheIds;
  var result = [];
  var item;
  var now = new Date().valueOf();
  for (var i = 0, iLen = data.length; i < iLen; i++) {
    item = data[i];
    if (typeof item.id == 'undefined') {
      result.push(item);
    } else {
      if (typeof cacheIds[item.id] == 'undefined') {
        cacheIds[item.id] = now;
        result.push(item);
      } else if (now - cacheIds[item.id] > 10 * 60 * 1000 && item.__type == 'online') {
        cacheIds[item.id] = now;
        result.push(item);
      }
    }
  }
  return result;
};

DataCenter.prototype.start = function () {
  this.isStart = true;
};

DataCenter.prototype.stop = function () {
  this.isStart = false;
};

Events.mixTo(DataCenter);
module.exports = DataCenter;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/dataCenter/live.js